import { AnaColumn } from "../forms-template.service";
import { createGridConfig, gridMultiple, gridSimple } from "./gridSettings/gridSettings";


export const VivifirxFIRBlocchi: AnaColumn[] = [
  {
    itemType: "group", caption: '', colCount: "1", data: [


      {
        type: 'campoSpecial', colVisible: true,
        dataField: 'codice_blocco',
        dataType: '',
        caption: 'Blocco',
        colWidth: 60,
        allowEditing: true,
        colAlignment:'center'
      },
      {
        type: 'campoSpecial', colVisible: true,
        dataField: 'descrizione',
        dataType: '',
        caption: 'Descrizione',
        colWidth: 220,
        allowEditing: true,
      },
      /* {
        type: 'campoSpecial', colVisible: true,
        dataField: 'numero_fir_vidimati',
        dataType: '',
        caption: 'N.FIR',
        colWidth: 60,
        allowEditing: true,
      }, */
      {
        type: 'campoSpecial', colVisible: true,
        dataField: 'disattivo',
        dataType: '',
        caption: 'stato',
        trueText: 'Non attivo',
        falseText: 'Attivo',
        colWidth: 90,
        allowEditing: true,
      }
    ]
  }
]

export const VivifirBlocchi: AnaColumn[] = [
  {
    itemType: "group", caption: '', colCount: "1", data: [


      {
        type: 'campoSpecial', colVisible: true,
        dataField: 'idfir',
        dataType: '',
        caption: 'Blocco',
        colWidth: 60,
        allowEditing: true,
      },
      {
        type: 'campoSpecial', colVisible: true,
        dataField: 'denominazione',
        dataType: '',
        caption: 'Denominazione',
        colWidth: 220,
        allowEditing: true,
      },
     /*  {
        type: 'campoSpecial', colVisible: true,
        dataField: 'numeroEFIR',
        dataType: 'number',
        caption: 'N.FIR',
        colWidth: 60,
        allowEditing: true,
      }, */
      {
        type: 'campoSpecial', colVisible: true,
        dataField: 'disattivo',
        dataType: 'boolean',
        caption: 'stato',
        trueText: 'Non attivo',
        falseText: 'Attivo',
        colWidth: 90,
        allowEditing: true,
      }
    ]
  }
]


export const ViviFirBlocchiAzienda: AnaColumn[] = [
  {
    itemType: "group", caption: '', colCount: "1", data: [

      {
        type: 'campoSpecial', colVisible: true,
        dataField: "blocco",
        
        caption: "Blocco",
        disableOnUpdate: true,
        colWidth: 95,
        validation:[{ type: 'required', message: 'Scegliere almeno un blocco'}],
        dynamic: {
          dataSource: 'ViviFir',
          displayExpr: 'idfir',
          service:'VivifirBlocchi',
          valueExpr: '',
          queryString: '/blocchiVirtuali?idSoggetto=$soggetto',
          autocomplete: false,
          related: ['denominazione|descrizione', 'disattivo|isAnnullato','nFirLiberi'],
          buttonOption: {
            text: 'blocchiVirtuali',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'blocchiVirtuali',
            name: 'blocchiVirtuali',
            location: 'after',
          },
          componentType: 'dynamicGrid',
          settingGrid: gridSimple



        }


      },

      {
        type: 'campo', colVisible: true, dataField: "descrizione",
        caption: "Descrizione",
        showEditorAlways: false,
        allowEditing: false,
        colWidth: 200,
      },
      {
        type: 'campo', colVisible: true, dataField: "elencoPosizioni",
        caption: "Posizioni",
        colWidth: 350,
        disableOnUpdate: true,
        dynamic: {
          dataSource: 'PosizioneRifiuti',
          autocomplete: false,
          service: 'generic',
          valueExpr: '',
          displayExpr: 'descrizione',
          caption: "Lista Posizioni rifiuto",
          queryString: '',
          componentType: 'dynamicGrid',
          related: ['id|listaPosizioni'],
          buttonOption: {
            text: 'Lista Posizioni rifiuto',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia posizioni rifiuto',
            name: 'poisizioneRifiuti',
            location: 'after',

          },
          settingGrid: gridMultiple

        }

      },
      {
        type: 'campo',
        dataField: 'numeroFirLiberi',
        colVisible: true,
        showEditorAlways: false,
        allowEditing: false,
        caption: 'N.FIR',
        colWidth: 50,

      },
      {
        type: 'campo',
        dataField: 'isAnnullato',
        colVisible: true,
        showEditorAlways: false,
        allowEditing: false,
        trueText: 'No',
        falseText: 'Si',
        editorType: 'dxCheckBox',
        caption: 'Attivo',
        colWidth: 50,
      },
      {
        type: 'button',
        dataField: "vidima",
        dataType: "",
        caption: "Vidima/Dettaglio",
        colWidth: '120',
        allowEditing: false,
        button: {
          icon: 'mdi mdi-vector-combine',
          text: 'vidima',
          name: 'vidima',
          hint: 'Mostra dettaglio del blocco e vidima',
          event: 'vidima'
        }
      },


    ]
  }

]